import { tracking } from '../strings.locstring.json';
import loc from 'owa-localize';
import * as React from 'react';
import getFullComposeViewState from 'owa-calendar-compose-form-store/lib/selectors/getFullComposeViewState';
import { getComposeStore } from 'owa-calendar-compose-store-manager';
import SidePane from 'owa-calendar-sidepane/lib/component/SidePane';
import SidePaneType from 'owa-calendar-sidepane/lib/schema/SidePaneType';

import { AttendeePanel } from 'owa-vertical-recipient-well';
import { getComposeCalendarColorScheme } from 'owa-calendar-compose-form-store/lib/selectors/getComposeCalendarColorScheme';
import { observer } from 'mobx-react-lite';
import { updateSidePaneType } from 'owa-calendar-compose-form-actions';

const styles = require('./TrackingSidePane.scss');

const TrackingSidePane = observer(function TrackingSidePane() {
    const { event } = getComposeStore();
    const fullComposeViewState = getFullComposeViewState();
    const colorScheme = getComposeCalendarColorScheme();

    return (
        <SidePane
            title={loc(tracking)}
            isOpened={fullComposeViewState.currentSidePaneType == SidePaneType.Tracking}
            onClose={hidePane}>
            <div className={styles.trackingPanel}>
                <AttendeePanel calendarEvent={event} colorScheme={colorScheme} />
            </div>
        </SidePane>
    );
});

function hidePane() {
    updateSidePaneType(SidePaneType.None);
}

export default TrackingSidePane;
